import dayjs from 'dayjs';
import { FC } from 'react';
import { AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import { TbRestore } from 'react-icons/tb';
import { Link } from 'react-router-dom';
import { ActionsIcon } from '../../../../../assets/svg/actions';
import { IconButton } from '../../../../../components/icon-button/icon-button';
import { HasAccess } from '../../../../../features/has-access/has-access';
import { Tooltip } from '../../../../../features/tooltip/tooltip';
import { buildParams, concatPath } from '../../../../../helpers/path';
import { useLang } from '../../../../../hooks/use-lang';
import { useQueryParams } from '../../../../../hooks/use-query-params';
import { ManagerPath, PromotionPath, RootPath } from '../../../../../routes/manager/manager-enums';
import { promoStatusMap, PromoStatusType } from '../../../../../store/api/promotion-api';
import { usePromotionStore } from '../../../../../store/use-promotion-store';
import s from './promo-cards.module.css';

interface Props {
  onEnd?: () => void;
}

export const PromoCards: FC<Props> = () => {
  const { list, isLoadingFetch } = usePromotionStore();
  const { t, getLocale } = useLang();
  const { addQueryParams } = useQueryParams();

  if (!list?.length && !isLoadingFetch) {
    return <div>{t('Здесь пока нет акций')}</div>;
  }

  return (
    <ul className={s.feature}>
      {list?.map((item) => {
        return (
          <li key={item.id} className={s.card}>
            <div className={s.title}>
              <div className={s.inUse}>
                {t('Статус')}
                <span>{t(promoStatusMap[item.status as PromoStatusType])}</span>
              </div>

              <HasAccess service="promotion" permissions={['write']}>
                {item.is_deleted ? (
                  <IconButton
                    tooltip={t('Восстановить')}
                    variant="secondary"
                    size="sm"
                    onClick={() =>
                      addQueryParams({
                        restoreId: String(item.id),
                        restoreName: getLocale(item.name),
                      })
                    }
                  >
                    <TbRestore />
                  </IconButton>
                ) : (
                  <Tooltip
                    triggerWrapperClassName={s.actionsButton}
                    optionsWrapperClassName={s.actions}
                    trigger={<ActionsIcon />}
                    offset={12}
                  >
                    <div className={s.actions}>
                      <Link
                        to={
                          concatPath([
                            RootPath.Manager,
                            ManagerPath.Promotion,
                            PromotionPath.Create,
                          ]) + buildParams({ id: item.id })
                        }
                      >
                        <IconButton tooltip={t('Редактировать')} size="sm" variant="secondary">
                          <AiOutlineEdit />
                        </IconButton>
                      </Link>
                      <IconButton
                        tooltip={t('Удалить')}
                        size="sm"
                        variant="secondary"
                        onClick={() =>
                          addQueryParams({
                            deleteId: String(item.id),
                            deleteName: getLocale(item.name),
                          })
                        }
                      >
                        <AiOutlineDelete />
                      </IconButton>
                    </div>
                  </Tooltip>
                )}
              </HasAccess>
            </div>
            <span className={s.name}>{getLocale(item.name)}</span>
            <div className={s.description}>
              {t('Описание')} <span>{getLocale(item.description) || t('Не указано')}</span>
            </div>
            <div className={s.dates}>
              <div className={s.period}>
                {t('Начало')}
                <span>{dayjs(item.active_from).format('DD.MM.YYYY (HH:mm)')}</span>
              </div>
              <div className={s.period}>
                {t('Завершение')}
                <span>{dayjs(item.active_to).format('DD.MM.YYYY (HH:mm)')}</span>
              </div>
            </div>
          </li>
        );
      })}
      {/* <InfiniteScroll onEnterView={onEnd} /> */}
    </ul>
  );
};
